interface IBtnCheckoutConfig {
  nodeLists: IBtnCheckoutNodeLists,
  selectors: IBtnCheckoutSelectors,
  classNames: IBtnCheckoutClassNames
}

interface IBtnCheckoutNodeLists {
  main: NodeList
}

interface IBtnCheckoutSelectors {
  main: string
}

interface IBtnCheckoutClassNames {
  loading: string
}

class BtnCheckout {

  private config: IBtnCheckoutConfig;

  constructor() {
    this.config = {
      nodeLists: {
        main: null
      },
      selectors: {
        main: '[data-btn-checkout]'
      },
      classNames: {
        loading: 'btn--loading'
      }
    }
  }

  public init() {
    this.config.nodeLists.main = document.querySelectorAll(this.config.selectors.main);
  }
  
  public loading() {
    this.config.nodeLists.main.forEach((htmlElement: HTMLElement) => {
      htmlElement.classList.add(this.config.classNames.loading);
    });
  }
  
  public loaded() {
    this.config.nodeLists.main.forEach((htmlElement: HTMLElement) => {
      htmlElement.classList.remove(this.config.classNames.loading);
    });
  }
  
}

export default new BtnCheckout();

